@if (currentPage().data.length > 0) {
  <div class="invoice-details-card-container">
    <div class="column-headings">
      <div class="remaining-amount-heading">REMAINING</div>
    </div>
    @for (invoice of currentPage().data; track invoice) {
      <a (click)="buttonClicked.emit(invoice)" (keydown.enter)="buttonClicked.emit(invoice)" tabindex="0" class="card" [attr.aria-label]="invoice.DetailsLabel">
        <div class="left-elements">
          <div class="invoice-number">{{invoice.InvoiceNumber}}</div>
          <div class="lower-elements">
            <div class="date">{{invoice.InvoiceDateString}}</div>
            <div class="currency-code">{{invoice.CurrencyCode}}</div>
          </div>
        </div>
        <div class="right-elements">
          <div class="remaining-amount">{{invoice.AmountRemaining.displayValue}}</div>
        </div>
      </a>
    }
  </div>
}
